import { GridSpacer } from '@bnnvara/grids';
import React from 'react';

const ComposableGridSpacer = (props) =>
  React.createElement(GridSpacer, {
    heightSm: '0',
    heightMd: '16px',
    heightLg: '16px',
    ...props,
  });

export default ComposableGridSpacer;
